







import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import Timeline from '@/models/Timeline';
import Folder from '../../models/Folder';
import FolderCommands from '../../networking/Folder';
import { BvModalEvent } from 'bootstrap-vue';

@Component({
	computed: {
		...mapGetters([
            'checkTimelineAdmin',
            'folders'
		])
    }
})
export default class TimelineMover extends Vue {
    @Prop(Timeline) readonly timeline! : Timeline;
    get typedFolders()
    {
        return ((this as any).folders as Map<number, Folder>);
    }

    private get _uncategorizedFolder()
    {
        let uncategorized = new Folder;
        uncategorized.id = <number><any>null;
        uncategorized.name = 'Uncategorized';
        uncategorized.description = '';
        return uncategorized;
    }

    selected = this._uncategorizedFolder;

    get folderSelection()
    {
        let folders = Array.from(this.typedFolders.values());
        folders.sort((a, b) => 
        {
            // numeric == natural sort, base sensitivity == case insensitive
            return a.name.trim().localeCompare(b.name.trim(), undefined, {numeric: true, sensitivity: 'base'});
        });

        folders.push(this._uncategorizedFolder);
        return folders;
    }

    get options()
    {
        return this.folderSelection.map(a=>{return { value: a, text: a.name }})
    }

    async move()
    {
        await FolderCommands.SetTimelineFolderByID(this.timeline.id, this.selected.id);
    }

    async ok(modal : BvModalEvent)
    {
        modal.preventDefault();
        try
        {
            // TODO: Display loading...
            await this.move();
            // TODO: Stop displaying loading
        }
        catch(ex)
        {
            alert(ex);
        }
        this.$emit('close');
    }

    mounted()
    {
        for(let v of this.options)
        {
            if (this.timeline.folderid == v.value.id)
            {
                this.$set(this, 'selected', v.value);
                break;
            }
        }
    }
}
